import { useNavigationContext } from '../context/NavigationContext';

interface NavBadgeProps {
  badge: boolean | string | undefined;
}

export const NavBadge = ({ badge }: NavBadgeProps) => {
  const { isNavCollapsed } = useNavigationContext();

  if (badge === undefined || badge === false) {
    return null;
  }

  const text = typeof badge === 'string' ? badge : 'NEW';

  if (isNavCollapsed) {
    return (
      <span className="bg-primary text-typography absolute -top-0.5 -right-0.5 flex h-[14px] min-w-[14px] items-center justify-center rounded-full px-0.5 text-[9px] font-medium">
        {text}
      </span>
    );
  }

  return (
    <span className="bg-primary text-typography flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1 text-[10px] font-medium">
      {text}
    </span>
  );
};
